import { SortableFilter }          from './../common/sortable-filter';

export class TrainClassSortableFilter extends SortableFilter {
    public in: number;
    public name: number;
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/train-class-list/train-class-list-sortable-filter.ts